import styled from 'styled-components';
import { IC_RIGHT_PAGINATION_ARROW } from '../../../Assets/images';

export const QuickLinksStyled = styled.div`
  .quicklinks-wrapper {
    display: grid;
    grid-template-columns: auto auto auto auto;
    gap: 16px;
    margin-bottom: 16px;

    .card-wrapper {
      width: 100%;
      transition: all 0.3s;

      &:hover {
        background-color:${(props) => props?.theme?.blue?.iconBg};
        border-color: ${(props) => props?.theme?.blue?.dark};
        .title {
          color: ${(props) => props?.theme?.blue?.dark};
        }
      }
    }
    .quicklinks-body {
      padding: 0px;
    }

    a {
      text-decoration: none;
    }
    .quick-wrapper {
      display: flex;
      flex-direction: row;
      width: 200px;
      padding-left: 20px;
      align-items: center;
      .title {
        color: ${(props) => props?.theme?.text?.dark};
        font-family: 'Mulish';
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        margin: 20px 0px 20px 8px;
        align-items: center;
      }
      .arrow {
        width: 7px;
        height: 12px;
        background: url(${IC_RIGHT_PAGINATION_ARROW.src}) no-repeat 50% 50% / cover;
        position: absolute;
        top: 25px;
        right: 10px;
        z-index: 1;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 820px) {
    .quicklinks-wrapper {
      grid-template-columns: auto auto;
      .quick-wrapper {
        .arrow {
          display: none;
        }
      }
    }
  }
`;
